import { render } from "./dynamic.vue?vue&type=template&id=63dff53e&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"

import "./dynamic.vue?vue&type=style&index=0&id=63dff53e&lang=scss&scoped=true"
import "./dynamic.vue?vue&type=style&index=1&id=63dff53e&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dff53e"]])

export default __exports__